import { Tooltip } from '@mantine/core'
import React, { ReactElement, ReactNode } from 'react'

type TransitionMantineTooltipProps = {
  tooltip?: ReactNode
  children?: ReactNode
}

const TransitionMantineTooltip = ({
  tooltip,
  children,
}: TransitionMantineTooltipProps): ReactElement => {
  if (!children) {
    return <></>
  }
  if (!tooltip) {
    return <>{children}</>
  }
  return (
    <Tooltip
      label={tooltip}
      withArrow
      withinPortal
      width="auto"
      disabled={!tooltip}
      multiline
      styles={{
        tooltip: {
          maxWidth: 300,
        },
      }}
      zIndex={2000}
    >
      <div>{children}</div>
    </Tooltip>
  )
}

export default TransitionMantineTooltip
